import { ComponentType } from "react";
import dynamic from "next/dynamic";
import { SubmenuKeys } from "@nf/constants";

export interface ISettingsSection {
  key: string;
  titleKey: string;
  wide?: boolean;
  hiddenForPartner?: boolean;
  Component: ComponentType;
}

export const SETTINGS_SECTIONS: ISettingsSection[] = [
  {
    key: SubmenuKeys.PERSONAL_DETAILS,
    titleKey: "web_my_account_menu_personal_details",
    Component: dynamic(() => import("./SettingsPersonalDetails")),
  },
  {
    key: SubmenuKeys.CHANGE_PASSWORD,
    titleKey: "web_my_account_menu_change_password",
    Component: dynamic(() => import("./SettingsChangePassword")),
  },
  {
    key: SubmenuKeys.SUBSCRIPTION,
    titleKey: "web_my_account_menu_subscription",
    Component: dynamic(() => import("./SettingsSubscription")),
  },
  {
    key: SubmenuKeys.PROFILES,
    titleKey: "web_my_account_menu_profiles",
    wide: true,
    Component: dynamic(() => import("./SettingsProfiles")),
  },
  {
    key: SubmenuKeys.WATCH_HISTORY,
    titleKey: "web_my_account_menu_watch_history",
    Component: dynamic(() => import("./SettingsWatchHistory")),
  },
  {
    key: SubmenuKeys.PAYMENT_DETAILS,
    titleKey: "web_my_account_menu_payment_details",
    hiddenForPartner: true,
    Component: dynamic(() => import("./SettingsPaymentDetails")),
  },
  {
    key: SubmenuKeys.PAYMENT_HISTORY,
    titleKey: "web_my_account_menu_payment_history",
    Component: dynamic(() => import("./SettingsPaymentHistory")),
    hiddenForPartner: true,
  },
  {
    key: SubmenuKeys.DEVICES,
    titleKey: "web_my_account_menu_devices",
    Component: dynamic(() => import("./SettingsDevices")),
  },
  {
    key: SubmenuKeys.GIFT,
    titleKey: "web_my_account_menu_gift",
    Component: dynamic(() => import("./SettingsGift")),
  },
];

export const isSettingsSectionAvailable = (
  section: ISettingsSection,
  isViaPartner: boolean
) => !(section.hiddenForPartner && isViaPartner);
